import { Plugin } from 'prosemirror-state';
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './FloatingToolbar.scss';
import { findDomRefAtPos } from 'prosemirror-utils';
import { Select } from 'antd';
class FloatingMenuView extends PureComponent {
  constructor() {
    super(...arguments);
    this.renderLabel = label => /*#__PURE__*/React.createElement("span", {
      className: "tap-floating-label"
    }, label);
    this.renderDropdown = (dropdownItems, valueAttrKey, onChange) => {
      const {
        pluginState = {}
      } = this.props;
      return /*#__PURE__*/React.createElement(Select, {
        defaultValue: "inline",
        value: pluginState.attrs[valueAttrKey],
        onChange: onChange
      }, dropdownItems.map(option => /*#__PURE__*/React.createElement(Select.Option, {
        value: option.value
      }, option.label)));
    };
    this.handleChange = handler => event => {
      const {
        editorView,
        pluginState = {}
      } = this.props;
      handler(editorView.state, editorView.dispatch, editorView, pluginState, event);
    };
    this.handleMouseDown = event => {
      event.preventDefault();
    };
  }
  render() {
    const {
      items,
      pluginState = {}
    } = this.props;
    const {
      activeToolbarItem
    } = pluginState;
    return /*#__PURE__*/React.createElement("div", {
      className: "tap-floating-menucont"
    }, items.map(_ref => {
      let {
        id,
        separator,
        icon,
        label,
        title,
        onClick,
        type,
        dropdownItems,
        valueAttrKey,
        renderContent
      } = _ref;
      const wrapperClass = "tap-floating-menuitem".concat(activeToolbarItem === id ? ' active' : '');
      if (renderContent) {
        return renderContent(wrapperClass, {
          props: this.props
        });
      }
      return separator ? /*#__PURE__*/React.createElement("div", {
        key: id,
        className: "tap-floating-seperator"
      }) : /*#__PURE__*/React.createElement("div", {
        key: id,
        className: wrapperClass,
        title: title,
        role: "button",
        tabIndex: "0",
        onClick: type !== 'dropdown' ? this.handleChange(onClick) : null,
        onMouseDown: this.handleMouseDown
      }, icon && /*#__PURE__*/React.createElement("div", {
        className: "ProseMirror-icon"
      }, /*#__PURE__*/React.createElement("span", {
        className: icon
      })), label && this.renderLabel(label), type === 'dropdown' && this.renderDropdown(dropdownItems, valueAttrKey, this.handleChange(onClick)));
    }));
  }
}
FloatingMenuView.propTypes = {
  editorView: PropTypes.object.isRequired,
  items: PropTypes.array,
  pluginState: PropTypes.object
};
FloatingMenuView.defaultProps = {
  items: [],
  pluginState: {}
};
class FloatingMenu {
  constructor(pluginKey, info, editorView) {
    this.pluginKey = pluginKey;
    this.info = info;
    this.editorView = editorView;
    this.dom = null;
  }
  updatePosition(pos, editorView) {
    var _pluginState$attrs;
    const domRef = findDomRefAtPos(pos, editorView.domAtPos.bind(editorView));
    const {
      y,
      height,
      x,
      width: nodeWidth
    } = domRef.getBoundingClientRect();
    const {
      y: editorY,
      x: editorX,
      width: editorWidth,
      height: editorHeight
    } = domRef.closest('.tap-editor').getBoundingClientRect();
    const top = y - editorY + height;
    this.dom.style.display = 'flex';
    this.dom.style.left = '0';
    this.dom.style.right = '0';
    if (top >= editorHeight) {
      this.dom.style.top = 'auto';
      this.dom.style.bottom = '35px';
    } else {
      this.dom.style.top = "".concat(top, "px");
      this.dom.style.bottom = 'auto';
    }
    const pluginState = this.pluginKey.getState(editorView.state);
    if (this.info.inline || (pluginState === null || pluginState === void 0 || (_pluginState$attrs = pluginState.attrs) === null || _pluginState$attrs === void 0 ? void 0 : _pluginState$attrs.wrapType) === 'inline') {
      this.dom.style.display = 'inline';
      const {
        width: toolbarWidth
      } = this.dom.getBoundingClientRect();
      const left = x - editorX + (nodeWidth - toolbarWidth) / 2;
      if (left + toolbarWidth >= editorWidth + editorX) {
        this.dom.style.left = 'auto';
        this.dom.style.right = '0';
      } else {
        this.dom.style.left = "".concat(left < 0 ? 0 : domRef.className.includes('right') ? editorWidth - toolbarWidth : left, "px");
        this.dom.style.right = 'auto';
      }
    }
  }
  update(editorView) {
    const {
      state,
      dom: editorDom
    } = editorView;
    const pluginState = this.pluginKey.getState(state);
    if (editorView.editable && pluginState && pluginState.pos !== null) {
      if (!this.dom) {
        this.dom = document.createElement('div');
        this.dom.className = 'tap-floating-menu';
      }
      let items = this.info && this.info.items ? this.info.items : [];
      if (this.info && this.info.onFilter) {
        items = this.info.onFilter(editorView, pluginState, items);
      }
      ReactDOM.render( /*#__PURE__*/React.createElement(FloatingMenuView, {
        key: "".concat(this.pluginKey.key, "-").concat(pluginState.pos),
        pluginState: pluginState,
        items: items,
        editorView: editorView
      }), this.dom);
      editorDom.parentNode.insertBefore(this.dom, editorView.dom);
      this.updatePosition(pluginState.pos, editorView);
    } else if (this.dom) {
      this.dom.remove();
      this.dom = null;
    }
  }
  destroy() {
    if (this.dom) {
      this.dom.remove();
    }
  }
}
export function floatingToolbarPlugin(pluginKey, info) {
  return new Plugin({
    view(editorView) {
      const menuView = new FloatingMenu(pluginKey, info, editorView);
      return menuView;
    }
  });
}
export default {
  name: 'floatingToolbar',
  configure: () => ({
    nodes: {},
    markers: {},
    plugin: floatingToolbarPlugin,
    floatingToolbars: []
  })
};